import { render } from "./DestinationPage.vue?vue&type=template&id=85c67fa2"
import script from "./DestinationPage.vue?vue&type=script&lang=js"
export * from "./DestinationPage.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/lbhq_agencyportal_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__